import { Team } from '../team/team.model';
import { UserCommission, UserMarkup } from '../user/user.model';

const groupKeys = [
    'id',
    'organizationId',
    'createdAt',
    'friendlyName',
    'defaultUserMarkup',
    'defaultUserCommission',
    'teams'
];

export class Group {
    constructor(group: Partial<Group>) {

        this.createdAt = new Date();
        this.defaultUserMarkup = new UserMarkup();
        this.defaultUserCommission = new UserCommission();
        this.teams = [];

        Object.assign(this, group);
        for(const key of groupKeys)
            if (this[key] == null)
                throw Error(`${key} must not be null`);
    }

    id: string;
    organizationId: string;
    createdAt: Date;
    friendlyName: string;

    // DEFAULT USER MARKUP TO BUY RATES
    defaultUserMarkup: UserMarkup;
    defaultUserCommission: UserCommission;

    teams: Array<Team>;

    static initFromName(friendlyName: string, organizationId: string): Partial<Group> {
        return {
            friendlyName,
            organizationId,
            defaultUserMarkup: new UserMarkup(),
            defaultUserCommission: new UserCommission(),
            teams: [] 
        } as Partial<Group>;
    }
}
